import React from 'react';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

class ClipText extends React.Component {
  insertText () {
    PubSub.publish('DICTATION_INSERT_TEXT', this.props.value);
  }

  render() {
    return (
      <div
        className="border border-grey-light py-1 px-3 rounded cursor-pointer transition duration-100 ease-in-out hover:bg-grey-light hover:font-bold"
        onClick={() => this.insertText()}>
        {this.props.text || this.props.value}
      </div>
    );
  }
}

ClipText.propTypes = {
  value: PropTypes.string.isRequired,
  text: PropTypes.string
};

ClipText.defaultProps = {};

export default ClipText;
